import React, { Component } from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-dropdown";
import "./Navbar.css";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.options = this.props.strings.getAvailableLanguages();
    this.onSelect = this.onSelect.bind(this);
  }

  onSelect(selected) {
    this.props.changeLannguage(selected.value);
  }

  render() {
    return (
      <div className="Navbar">
        <div className="Brand">HappyOrNot Visualizer</div>
        <Dropdown
          options={this.options}
          onChange={this.onSelect}
          value={this.props.lang ? this.props.lang : "en"}
        />
        <Link to="/" className="Reset">
          {this.props.strings.reset}
        </Link>
      </div>
    );
  }
}
export default Navbar;



// WEBPACK FOOTER //
// ./src/Navbar.js